var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.69 18.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    className: "cls-1",
    cx: 9.34,
    cy: 9.41,
    r: 4.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-1",
    d: "M13.82 5.33a.4.4 0 01-.39-.4.43.43 0 01.11-.28l1.84-1.83a.39.39 0 11.57.54L14.1 5.21a.4.4 0 01-.28.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-1",
    d: "M18.27 9.8h-2.6a.38.38 0 01-.41-.37.39.39 0 01.38-.43h2.63a.39.39 0 110 .78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-1",
    d: "M15.66 16.12a.39.39 0 01-.28-.12l-1.84-1.83a.4.4 0 010-.56.4.4 0 01.56 0l1.84 1.84a.39.39 0 010 .55.36.36 0 01-.28.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-1",
    d: "M9.35 18.73a.39.39 0 01-.4-.39H9v-2.6a.4.4 0 01.79 0v2.64a.39.39 0 01-.44.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-1",
    d: "M9.35 3.37A.4.4 0 019 3V.37A.4.4 0 019.37 0a.39.39 0 01.37.37V3a.4.4 0 01-.39.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-1",
    d: "M3 16.12a.4.4 0 01-.28-.67l1.84-1.84a.4.4 0 01.56 0 .41.41 0 010 .55L3.31 16a.36.36 0 01-.31.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-1",
    d: "M3 9.8H.41A.38.38 0 010 9.43.39.39 0 01.37 9H3a.39.39 0 110 .78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-1",
    d: "M4.87 5.33a.4.4 0 01-.28-.12L2.75 3.37a.39.39 0 01.54-.57l1.86 1.85a.4.4 0 010 .56.44.44 0 01-.28.12z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunFull);
export default __webpack_public_path__ + "static/media/sun-full.7b3c2412012520ec109f75d7358493a0.svg";
export { ForwardRef as ReactComponent };